export const PLATFORM_UPC = 'upc';
export const PLATFORM_WEB = 'web';

export type Platform = "upc" | "web" | null;
